import React from 'react';
import { IntlProvider } from 'react-intl';
import Education from '../components/Education/Education';
import ErrorBoundary from '../components/ErrorBoundary';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import SingleColumnTemplate from '../../../ui/layouts/SingleColumnTemplate.jsx';
import getMessages from '../lib/i18n/getMessages';
import { CurrencyProvider } from '../hooks/useCurrency';

const EducationContainer = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = railsContext && railsContext.currency;
  const locale = window.locale;
  const { current_user, company, educational_contents, features, theme_name } = props;

  // Extract company data for theming (following same pattern as SuccessionDashboardContainer)
  const companyData = company || {
    id: railsContext?.company_id,
    name: railsContext?.company_name,
    host: railsContext?.company_host,
    primary_color: props?.primary_color,
    secondary_color: props?.secondary_color,
    neutral_color: props?.neutral_color,
    accent_color: props?.accent_color,
  };

  console.log('EducationContainer - Company data for theming:', companyData);

  const currentUserLocale = locale;

  const t = getMessages(locale);
  const educationTitle = t['succession.education.title'] || 'Education Resources';
  const educationSubtitle = t['succession.education.subtitle'] || 'Access educational materials and resources to help with your planning.';
  const educationNoContent = t['succession.education.no_content'] || 'No educational content found.';

  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
      <SuccessionThemeProvider
        company={companyData}
        user={current_user}
      >
        <ErrorBoundary>
          {educational_contents && educational_contents.length > 0 ? (
            <Education
              educationalContents={educational_contents}
              currentUserLocale={currentUserLocale}
            />
          ) : (
            <SingleColumnTemplate
              title={educationTitle}
              subtitle={educationSubtitle}
              columnClassName="max-w-2xl"
              columnStyle={{ maxWidth: '55rem' }}
            >
              <div className="flex justify-center items-center h-64 bg-succession-bg-primary rounded-lg border border-succession-border transition-colors duration-300">
                <div className="text-succession-text-secondary transition-colors duration-300">{educationNoContent}</div>
              </div>
            </SingleColumnTemplate>
          )}
        </ErrorBoundary>
      </SuccessionThemeProvider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default EducationContainer; 
